import { HttpLink } from 'apollo-angular/http';
import { ApolloClientOptions, ApolloLink, InMemoryCache } from '@apollo/client/core';
import { environment } from '../environments/environment';
import { setContext} from '@apollo/client/link/context'
import { LocalAuthService } from './auth/local-auth.service';

export function createApollo(httpLink: HttpLink, auth: LocalAuthService): ApolloClientOptions<any> {
  

  const authContext = setContext(async(_, {headers}) => {

    let token =  auth.getAuthToken()

    if (auth.isAuthTokenExpired()) {
      await auth.refreshLogin() 
      token =  auth.getAuthToken()
    }

    return {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  })
  
  return {
    link: ApolloLink.from([authContext, httpLink.create({uri: environment.config.GRAPHQL_ENDPOINT})]),
    cache: new InMemoryCache(),
  };
}

